import { DEFAULTS } from '@monsido/ng2/core/constants/defaults.constant';

(function () {
    'use strict';

    angular.module('constants').constant('DATE_FORMAT', DEFAULTS.DATE_FORMAT);
    angular.module('constants').constant('API_REQUEST_DATE_FORMAT', DEFAULTS.API_REQUEST_DATE_FORMAT);
})();
